import { useCallback, useEffect, useState } from 'react';
import { NetworkResult } from './CommonResult';
import { API } from '../api';

export const nextStatusList = (statusList: any, status: string) => {
  const parcelStatus = statusList.find(
    (parcel: any) => parcel.cd.toUpperCase() === (status || '').toUpperCase()
  );
  const nextStatus = parcelStatus?.nextStatus || {};
  const items: string[] = (nextStatus.HOMEDELIVERY || []).concat(nextStatus.PICKUP || []);
  const uniqueArrayList: string[] = [...new Set(items)];
  return statusList.filter((it: any) => uniqueArrayList.indexOf(it.cd) > -1 && it.canScan);
};

export const useDeliveryStatusList = (): [NetworkResult<any[]>, Function] => {
  const [data, setData] = useState<NetworkResult<any[]>>({ loading: false, result: [] });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setData({ loading: true, result: [] });
      const response = await API.get({ apiVersion: 'api' })('/delivery/status/list');
      setData({ loading: false, result: response.result.list });
    } catch (e) {
      console.error(e);
      setData({ loading: false, result: [] });
    }
  }, []);

  return [data, fetchData];
};
